export default __webpack_public_path__ + "static/media/ISCO CLASS-4_SYLLABUS_2025-26.ee076d9b.pdf";